export default __webpack_public_path__ + "static/media/soyCandidato.ba05cb9b.svg";